module.exports = __webpack_public_path__ + "img/bg9.29dc83f3.jpg";